import "core-js/modules/es.array.includes.js";
import React from 'react';
import isMultiDomain from 'utils/isMultiDomain';
import Stack from 'components/Stack';
import GeneralDetailsCard from './Cards/GeneralDetailsCard';
import AdvancedSettingsCard from './Cards/AdvancedSettingsCard';
import LinkDetailsCard from './Cards/LinkDetailsCard';
import FileDetailsCard from './Cards/FileDetailsCard';
import EventSettingsCard from './Cards/EventSettingsCard';
import FormWrapper from './FormWrappers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AssetDetailsModal = function AssetDetailsModal(_ref) {
  var _ref$isEditMode = _ref.isEditMode,
    isEditMode = _ref$isEditMode === void 0 ? false : _ref$isEditMode,
    isNewFile = _ref.isNewFile,
    isProcessingError = _ref.isProcessingError,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isSaving = _ref.isSaving,
    isSaving = _ref$isSaving === void 0 ? false : _ref$isSaving,
    isSubmitDisabled = _ref.isSubmitDisabled,
    inContentManagerContext = _ref.inContentManagerContext,
    hasChanges = _ref.hasChanges,
    showUploadProgress = _ref.showUploadProgress,
    fields = _ref.fields,
    uploadProgress = _ref.uploadProgress,
    assetContentType = _ref.assetContentType,
    content = _ref.content,
    aiSuggestions = _ref.aiSuggestions,
    onReplace = _ref.onReplace,
    onDelete = _ref.onDelete,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    resetValues = _ref.resetValues;
  var isDistributed = content ? isMultiDomain(content) : false;
  var initialAssetDetails = {
    author: content === null || content === void 0 ? void 0 : content.author,
    createdTime: content === null || content === void 0 ? void 0 : content.createdTime,
    lastUpdated: content !== null && content !== void 0 && content.lastUpdated ? new Date(content === null || content === void 0 ? void 0 : content.lastUpdated).toISOString() : undefined
  };
  function handleSubmit() {
    resetValues();
    onSubmit();
  }
  return /*#__PURE__*/_jsx(FormWrapper, {
    isEditMode: isEditMode,
    isLoading: isLoading,
    isError: isError,
    isSaving: isSaving,
    isSubmitDisabled: isSubmitDisabled,
    inContentManagerContext: inContentManagerContext,
    assetContentType: assetContentType,
    hasChanges: hasChanges,
    onSubmit: handleSubmit,
    onDiscard: resetValues,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(GeneralDetailsCard, {
        isEditMode: isEditMode,
        isDistributed: isDistributed,
        fields: fields,
        content: content,
        aiSuggestions: aiSuggestions,
        initialAssetDetails: initialAssetDetails
      }), assetContentType === 'event' && /*#__PURE__*/_jsx(EventSettingsCard, {
        isDistributed: isDistributed,
        fields: fields
      }), /*#__PURE__*/_jsx(AdvancedSettingsCard, {
        isDistributed: isDistributed,
        assetContentType: assetContentType,
        fields: fields,
        content: content
      }), assetContentType === 'web' && /*#__PURE__*/_jsx(LinkDetailsCard, {
        isDistributed: isDistributed,
        fields: fields
      }), !['web', 'event'].includes(assetContentType) && /*#__PURE__*/_jsx(FileDetailsCard, {
        isNewFile: isNewFile,
        isProcessingError: isProcessingError,
        isEditMode: isEditMode,
        isDistributed: isDistributed,
        showUploadProgress: showUploadProgress,
        uploadProgress: uploadProgress,
        onReplace: onReplace,
        onDelete: onDelete,
        content: content
      })]
    })
  });
};
export default AssetDetailsModal;